import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsOpsgenieRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-opsgenie',
	path: '/plugins/servlet/project-config/:projectKey/opsgenie',
};
